/**
 * Detects if the current browser is Safari
 * @returns {boolean} true if the browser is Safari
 */
export const isSafari = (): boolean => {
    // Check if browser is Safari
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1;
};

export default isSafari;
